import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})

@Injectable()
export class FilterPipe implements PipeTransform {
    transform(array: Array<any>, propName: string, itemContain: any): Array<any> {
        if (itemContain) {
            return array.filter(item => {
                return item[propName].toLowerCase().includes(itemContain.toLowerCase());
            } );
        } else {
            return array;
        }
    }
}
